import { render, staticRenderFns } from "./UniversityCreate.vue?vue&type=template&id=37de99ac&"
import script from "./UniversityCreate.vue?vue&type=script&lang=js&"
export * from "./UniversityCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports